import TickerItems from "../TickerItems";
import { SHOW_STANDINGS } from "../../constants-ticker";
import {
  createStandingItem,
  createStandingPhaseItem,
  getAmericanFootballStages,
  getAmericanFootballConferences,
  getAmericanFootballDivisions,
  getAmericanFootballTeams,
  getAmericanFootballRecord,
  getAmericanFootballTeamName,
} from "./tickerSportUtils";

/**
 * Contenido de football americano (sport_code AMFO).
 *
 * Los standings se agrupan por conferencia (American/National Football
 * Conference). El título de cada sección es el nombre de la conferencia
 * (conferences.name) y cada equipo muestra su logo, nombre y el récord
 * desglosado en ganados (W), perdidos (L) y porcentaje (PCT).
 */
export default function AmericanFootballTickerContent({ standing }) {
  const stages = getAmericanFootballStages(standing);

  const standings = SHOW_STANDINGS ? stages.flatMap((stage) => {
    const conferences = getAmericanFootballConferences(stage);

    return conferences.flatMap((conference) => {
      const divisions = getAmericanFootballDivisions(conference);
      // Se recorre división por división para que el index (rank) se reinicie
      // en cada una y corresponda a la posición dentro de esa división.
      const teams = divisions.flatMap((division) => getAmericanFootballTeams(division));
      if (!teams.length) return [];

      return [
        // Título de la sección: nombre de la conferencia (conferences.name).
        createStandingPhaseItem(conference?.name || conference?.abbreviation || "Conferencia"),
        ...divisions.flatMap((division) =>
          getAmericanFootballTeams(division).map((team, index) => {
            const wins = team?.record?.wins ?? team?.wins;
            const losses = team?.record?.losses ?? team?.losses;
            const percentage = team?.record?.percentage ?? team?.record?.winPercentage ?? team?.percentage ?? "";

            return createStandingItem({
              entry: {
                // Index correspondiente a cada división (se reinicia por división).
                rank: index + 1,
              },
              fallbackRank: index + 1,
              image: team?.image || team?.logo || "",
              name: getAmericanFootballTeamName(team),
              points: getAmericanFootballRecord(team),
              pointsLabel: "",
              // Récord desglosado con etiquetas: (W) 1 (L) 0 (PCT) 1.000
              stats: [
                { label: "W", value: wins },
                { label: "L", value: losses },
                { label: "PCT", value: percentage },
              ],
            });
          })
        ),
      ];
    });
  }) : [];

  return <TickerItems items={standings} />;
}
